export default "__VITE_ASSET__CTNl49EA__"